import type { IEnglishIqV2StoredFlow } from '../english-iq-v2-stored-flow';

export function resolveEnglishIqV2RestoredFlow(
  flow: IEnglishIqV2StoredFlow | null,
  sourceShareId: string | null,
  ownerSubject: string,
): IEnglishIqV2StoredFlow | null {
  if (!flow || flow.ownerSubject !== ownerSubject) {
    return null;
  }
  if (!sourceShareId) {
    return flow;
  }
  if (flow.view === 'result') {
    return flow.assessment.result?.shareId === sourceShareId ? flow : null;
  }
  return flow.sourceShareId === sourceShareId ? flow : null;
}
